import urls from "global/constants/UrlConstants";
import {
  getAuthCallParams,
  getNoAuthCallParams,
  makeCall,
} from "utils/service";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  authToken?: string;
  refreshToken?: string;
  access_token?: string;
  refresh_token?: string;
  user?: any;
  [key: string]: any;
}

export const loginUser = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const body = {
      email,
      password,
    };
    const callParams = getNoAuthCallParams("POST", body);
    const response: any = await makeCall(urls.LOGIN, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const signUpUser = async (
  name: string,
  email: string,
  password: string,
  contact_number?: string
): Promise<LoginResponse> => {
  try {
    const body: Record<string, string> = {
      name,
      email,
      password,
    };
    if (contact_number != null && contact_number.trim() !== "") {
      body.contact_number = contact_number.trim();
    }
    const callParams = getNoAuthCallParams("POST", body);
    const response: any = await makeCall(urls.SIGNUP, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const validateOTP = async (
  token: string,
  email: string,
  otp: string
): Promise<LoginResponse> => {
  try {
    const body = {
      email,
      otp,
    };
    const callParams = await getAuthCallParams(token, "POST", body);
    console.log(callParams);
    const response: any = await makeCall(urls.VALIDATE_OTP, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const resendOTP = async (email: string): Promise<LoginResponse> => {
  try {
    const body = { email };
    const callParams = getNoAuthCallParams("POST", body);
    const response: any = await makeCall(urls.RESEND_OTP, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const forgotPassword = async (email: string): Promise<any> => {
  try {
    const body = { email };
    const callParams = getNoAuthCallParams("POST", body);
    const response: any = await makeCall(urls.FORGOT_PASSWORD, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
